<div>
  <div class="row p-3">
    <div class="col-12">
      <app-products></app-products>
    </div>
  </div>
</div>